var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserEditForm',{attrs:{"id":_vm.id,"userType":_vm.UserType.MERCHANT}})}
var staticRenderFns = []

export { render, staticRenderFns }